var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('img',{staticClass:"md-image",style:({'heigth': _vm.heigth, 'width': _vm.width}),attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }